"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupCart = exports.CART_TYPE = void 0;
var tailwind_1 = require("../constants/tailwind");
var cart_schema_1 = require("../schema/cart.schema");
var axios_1 = __importDefault(require("../utils/axios"));
var guards_1 = require("../utils/guards");
var cart_modal_1 = require("./cart_modal");
/**
 * 言語選択があるかどうかを判定する
 * @param { FormElements } elements フォーム要素の集合
 * @returns { boolean } 言語選択が存在するかどうか
 */
var hasLanguageSelect = function (elements) { return 'languageSelect' in elements; };
exports.CART_TYPE = {
    LIST: 'list',
    DETAIL: 'detail',
};
var CLASSES = {
    SIZE_SELECT: 'js-size-select',
    LANGUAGE_SELECT: 'js-language-select',
    QUANTITY_INPUT: 'js-quantity-input',
    ADD_CART_BUTTON: 'js-add-cart',
    CART_FORM_ERRORS: 'js-cart-form-errors',
    HEADER_CART: 'js-header-cart',
};
/**
 * カートに追加する処理の初期化
 * @param { HTMLFormElement } form カートへ追加フォーム
 * @param { CartOptions } options カートのオプション
 */
var setupCart = function (form, options) {
    var type = options.type;
    var cartModal = cart_modal_1.CartModal.getInstance();
    var formElementsBase = {
        sizeSelect: form.querySelector(".".concat(CLASSES.SIZE_SELECT)),
        quantityInput: form.querySelector(".".concat(CLASSES.QUANTITY_INPUT)),
        productClassInput: form.querySelector('input[name="ProductClass"]'),
        addCartButton: form.querySelector(".".concat(CLASSES.ADD_CART_BUTTON)),
        cartFormErrors: form.querySelector(".".concat(CLASSES.CART_FORM_ERRORS)),
    };
    var formNameList;
    var formElements;
    var languageSelect = form.querySelector(".".concat(CLASSES.LANGUAGE_SELECT));
    if (!formElementsBase.sizeSelect) {
        // サイズ選択がない場合はquantityInputNameのみで初期化
        formElements = formElementsBase;
        formNameList = {
            quantityInputName: formElements.quantityInput.name,
        };
    }
    else {
        formElements = languageSelect ? __assign(__assign({}, formElementsBase), { languageSelect: languageSelect }) : formElementsBase;
        formNameList = hasLanguageSelect(formElements)
            ? {
                sizeSelectName: formElements.sizeSelect.name,
                languageSelectName: formElements.languageSelect.name,
                quantityInputName: formElements.quantityInput.name,
            }
            : {
                sizeSelectName: formElements.sizeSelect.name,
                quantityInputName: formElements.quantityInput.name,
            };
    }
    /**
     * フォームのイベントを初期化
     */
    var initFormEvent = function () {
        // サイズ選択のchangeイベント登録
        if (formElements.sizeSelect) {
            formElements.sizeSelect.addEventListener('change', function (e) {
                var target = e.target;
                if (!target)
                    return;
                var sizeId = target.value;
                var languageClassCategories = detectLanguageClassCategories(sizeId);
                // 言語選択が存在する場合
                if ((0, guards_1.hasLanguageSelectName)(formNameList)) {
                    handleSizeChange(languageClassCategories);
                }
                else {
                    handleSizeChangeForSingle(languageClassCategories);
                }
            });
        }
        // 言語選択のchangeイベント登録
        if (hasLanguageSelect(formElements)) {
            formElements.languageSelect.addEventListener('change', function (e) {
                var target = e.target;
                if (!target)
                    return;
                var name = target.name, languageId = target.value;
                var languageClassCategories = detectLanguageClassCategories(formElements.sizeSelect.value);
                handleLanguageChange(languageClassCategories, languageId, name);
            });
        }
        /**
         * 言語選択のカテゴリー情報を取得する
         * @param { string } sizeId 商品のサイズID
         * @returns { LanguageClassCategories } 言語選択のオプションカテゴリ
         */
        var detectLanguageClassCategories = function (sizeId) {
            var _a;
            var handlers = (_a = {},
                _a[exports.CART_TYPE.LIST] = function () {
                    // 商品一覧では商品IDが必ず存在する
                    var productId = form.dataset.productId;
                    return window.eccube.productsClassCategories[productId][sizeId];
                },
                _a[exports.CART_TYPE.DETAIL] = function () { return window.eccube.classCategories[sizeId]; },
                _a);
            return handlers[type]();
        };
        /**
         * サイズ変更イベントの処理（言語選択あり）
         * @param languageClassCategories 選択されたサイズに紐づいた言語のカテゴリ
         */
        var handleSizeChange = function (languageClassCategories) {
            handleStockStatus(true);
            toggleProductClassId();
            createLanguageSelectEl(languageClassCategories);
        };
        /**
         * サイズ変更イベントの処理（言語選択なし）
         * @param { LanguageClassCategories } nextClassCategories 商品規格２のカテゴリ
         */
        var handleSizeChangeForSingle = function (nextClassCategories) {
            var productDetail = Object.values(nextClassCategories)[0];
            // サイズが選択されていない場合
            if ((0, guards_1.isUnselectedProductDetail)(productDetail)) {
                handleStockStatus(true);
                toggleProductClassId(productDetail.product_class_id);
            }
            else {
                handleStockStatus(productDetail.stock_find);
                toggleProductClassId(productDetail.product_class_id);
            }
        };
        /**
         * 言語の変更イベント処理
         * @param { LanguageClassCategories } languageCategories 選択されたサイズに紐づいた言語のカテゴリ
         * @param { string } languageId 言語規格ID
         * @param { string } name 言語セレクトボックスのname属性
         */
        var handleLanguageChange = function (languageCategories, languageId, name) {
            var productDetail = Object.values(languageCategories)
                .filter(function (category) { return !(0, guards_1.isUnselectedProductDetail)(category); })
                .find(function (detail) { return detail[name] === languageId; });
            if (productDetail) {
                handleStockStatus(productDetail.stock_find);
                toggleProductClassId(productDetail.product_class_id);
            }
            else {
                handleStockStatus(true);
                toggleProductClassId();
            }
        };
        /**
         * 在庫状況によってボタンの表示を切り替える
         * @param { boolean } stockFind 在庫があるかどうか
         */
        var handleStockStatus = function (stockFind) {
            if (stockFind) {
                formElements.addCartButton.disabled = false;
                formElements.addCartButton.classList.remove(tailwind_1.TAILWIND_CLASSES.BG_ERROR);
                formElements.addCartButton.textContent = window.eccube_phrase.addCart;
            }
            else {
                formElements.addCartButton.disabled = true;
                formElements.addCartButton.classList.add(tailwind_1.TAILWIND_CLASSES.BG_ERROR);
                formElements.addCartButton.textContent = window.eccube_phrase.outOfStock;
            }
        };
        /**
         * 商品規格IDを付け替える
         * @param { string } [productClassId] 商品規格ID
         */
        var toggleProductClassId = function (productClassId) {
            formElements.productClassInput.value = productClassId ? productClassId : '';
        };
        /**
         * 言語の選択要素を生成
         * @param { LanguageClassCategories } languageClassCategories 選択されたサイズに紐づいた言語のカテゴリ
         */
        var createLanguageSelectEl = function (languageClassCategories) {
            // 言語選択が存在しない場合は何もしない
            if (!hasLanguageSelect(formElements) || !(0, guards_1.hasLanguageSelectName)(formNameList))
                return;
            var languageClassCategoryValues = Object.values(languageClassCategories);
            // 言語選択のオプションが１つ以下の時は未選択状態
            if (languageClassCategoryValues.length <= 1) {
                formElements.languageSelect.disabled = true;
                formElements.languageSelect.classList.add(tailwind_1.TAILWIND_CLASSES.TEXT_DISABLE);
            }
            else {
                formElements.languageSelect.disabled = false;
                formElements.languageSelect.classList.remove(tailwind_1.TAILWIND_CLASSES.TEXT_DISABLE);
            }
            // 選択されていない状態と選択されている状態で分割
            var _a = languageClassCategoryValues.reduce(function (_a, category) {
                var matched = _a[0], unmatched = _a[1];
                return (0, guards_1.isUnselectedProductDetail)(category)
                    ? [__spreadArray(__spreadArray([], matched, true), [category], false), unmatched]
                    : [matched, __spreadArray(__spreadArray([], unmatched, true), [category], false)];
            }, [[], []]), unselectedProductDetails = _a[0], languageSelectDetails = _a[1];
            // 言語選択セレクトのname属性
            var languageSelectName = formNameList.languageSelectName;
            // 言語規格IDで昇順にソート
            languageSelectDetails.sort(function (a, b) { return parseInt(a[languageSelectName]) - parseInt(b[languageSelectName]); });
            var unselectedOption = unselectedProductDetails.reduce(function (template, detail) {
                return template + "<option value>".concat(detail.name, "</option>");
            }, '');
            var languageOption = languageSelectDetails.reduce(function (template, detail) {
                return template + "<option value=\"".concat(detail[languageSelectName], "\">").concat(detail.name, "</option>");
            }, '');
            // DOMに反映
            formElements.languageSelect.innerHTML = unselectedOption + languageOption;
        };
    };
    /**
     * カート追加ボタンのクリックイベントを初期化
     */
    var initAddCartBtnClickEvent = function () {
        formElements.addCartButton.addEventListener('click', function (e) { return __awaiter(void 0, void 0, void 0, function () {
            var formData, addCartRes, data, updateCartRes, html_1, headerCartElms, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        e.preventDefault();
                        formData = new FormData(form);
                        if (!validateFormData(formData)) {
                            return [2 /*return*/];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 4, 5, 6]);
                        formElements.addCartButton.disabled = true;
                        return [4 /*yield*/, axios_1.default.post(form.action, formData)];
                    case 2:
                        addCartRes = _b.sent();
                        data = addCartRes.data;
                        cartModal.showModal(data.messages[0]);
                        return [4 /*yield*/, axios_1.default.get(window.eccube.cartBlockUrl)];
                    case 3:
                        updateCartRes = _b.sent();
                        html_1 = updateCartRes.data;
                        headerCartElms = document.querySelectorAll(".".concat(CLASSES.HEADER_CART));
                        headerCartElms.forEach(function (elm) {
                            elm.innerHTML = html_1;
                        });
                        return [3 /*break*/, 6];
                    case 4:
                        _a = _b.sent();
                        alert(window.eccube.cartErrorMessage);
                        return [3 /*break*/, 6];
                    case 5:
                        formElements.addCartButton.disabled = false;
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        }); });
        /**
         * フォームのバリデーション
         * @param { FormData } formData フォームデータ
         */
        var validateFormData = function (formData) {
            var data = Object.fromEntries(formData);
            // 検証
            var result = (0, cart_schema_1.createCartFormSchema)(formNameList).safeParse(data);
            if (!result.success) {
                var issues = result.error.issues;
                displayErrors(issues);
                return false;
            }
            clearErrors();
            return true;
        };
        /**
         * バリデーションエラーを表示
         * @param { $ZodIssue[] } issues バリデーションエラーのリスト
         */
        var displayErrors = function (issues) {
            formElements.cartFormErrors.innerHTML = '';
            issues.forEach(function (issue) {
                formElements.cartFormErrors.innerHTML += "<div>".concat(issue.message, "</div>");
                issue.path.forEach(function (path) {
                    var targetElement = (form.querySelector("[name=\"".concat(path.toString(), "\"]")));
                    if (!targetElement)
                        return;
                    targetElement.classList.add(tailwind_1.TAILWIND_CLASSES.BORDER_ERROR);
                });
            });
        };
        /**
         * バリデーションエラーをクリア
         */
        var clearErrors = function () {
            formElements.cartFormErrors.innerHTML = '';
            Object.values(formNameList).forEach(function (name) {
                var targetElement = form.querySelector("[name=\"".concat(name, "\"]"));
                if (targetElement) {
                    targetElement.classList.remove(tailwind_1.TAILWIND_CLASSES.BORDER_ERROR);
                }
            });
        };
    };
    // 初期化
    initFormEvent();
    initAddCartBtnClickEvent();
};
exports.setupCart = setupCart;
